import { colors } from 's1-ui';

const { buttonOrange } = colors;

export default {
  typography: {
    fontFamily: 'Roboto, Arial',
    useNextVariants: true
  },
  palette: {
    text: {
      primary: buttonOrange,
      secondary: buttonOrange
    },
    primary: {
      light: buttonOrange,
      main: buttonOrange,
      dark: buttonOrange
    },
    type: 'dark'
  }
};
